import React, { useEffect } from 'react';
import '../../styles/components/profile_page/LightBox.css';

export default function Lightbox({ photos = [], index, onClose, onPrev, onNext }) {
  const photo = photos[index];

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, onPrev, onNext]);

  if (index < 0 || !photo) return null;

  return (
    <div className="lb" onClick={onClose} role="dialog" aria-modal="true">
      <img
        src={photo.url}
        alt=""
        onClick={(e) => e.stopPropagation()}
      />
      <button className="lb-btn lb-prev" onClick={(e)=>{e.stopPropagation(); onPrev();}} aria-label="Previous">‹</button>
      <button className="lb-btn lb-next" onClick={(e)=>{e.stopPropagation(); onNext();}} aria-label="Next">›</button>
      <button className="lb-btn lb-close" onClick={(e)=>{e.stopPropagation(); onClose();}} aria-label="Close">✕</button>
    </div>
  );
}